export const contentSections = [
    {
        titleKey: 'WE_MAKE_IT_EASY_INVOICE_WITHOUT_COMPANY',
        textKeys: ['MAKE_IT_EASY_TEXT_1', 'MAKE_IT_EASY_TEXT_2']
    },
    {
        titleKey: 'ADVANTAGES_OF_SELF_EMPLOYMENT',
        textKeys: ['ADVANTAGES_SELF_EMPLOYMENT_TEXT']
    },
    {
        titleKey: 'START_INVOICING_IN_FEW_MINUTES',
        textKeys: ['START_INVOICING_TEXT']
    },
    {
        titleKey: 'INSURANCE_AS_SELF_EMPLOYED_WORKER',
        textKeys: ['INSURANCE_SELF_EMPLOYED_TEXT']
    },
    {
        titleKey: 'MINIMIZING_ADMINISTRATION',
        textKeys: ['MINIMIZING_ADMINISTRATION_TEXT_1', 'MINIMIZING_ADMINISTRATION_TEXT_2']
    }
];
